import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { ThUI } from './ui';

export class Th extends PureComponent {
    static displayName = 'ThContainer';

    render() {
        const { ...rest } = this.props;

        // PUT OTHER PROPS AFTER {...rest}
        return <ThUI {...rest} />;
    }
}

export const ThContainer = compose()(Th);
